export const DESKTOP_BANNER_HEIGHT = 239;
export const MOBILE_BANNER_HEIGHT = 250;
export const MOBILE_BANNER_HEIGHT_NO_CONTENT = 175;
